import { useNavigate } from "react-router-dom"
import { MultiStepFlowContainer } from "../Components/MultiStepFlow"
import { Title } from "../Components/Title"
import { Paragraph } from "../Components/Paragraph"
import { ActivitiesGroup } from "../Components/ActivitiesGroup"
import { MentorActivities, StudentActivities } from "../constants/stepRegistry"

const OnboardingTourFlow = () => {
  const navigate = useNavigate()

  const steps = [
    {
      id: "getting_started",
      renderCustomContent: () => (
        <div className="py-8 text-center">
          <Title>Getting Started</Title>
          <Paragraph>You&apos;re ready to get started!</Paragraph>
          <Paragraph>
            Mentor Circle Plans update in real-time as students and their Mentors complete a few
            simple activities.
          </Paragraph>
          <Paragraph>Let&apos;s see how it works!</Paragraph>
        </div>
      ),
      nextButtonText: "See What's Inside!",
    },
    {
      id: "student_activities",
      renderCustomContent: () => (
        <div className="py-8 text-center">
          <Title>Impactful Student Activities</Title>
          <Paragraph className="mx-auto max-w-3xl">
            Students complete four simple activities that lay the foundation for Mentor support.
          </Paragraph>
          <div className="mt-8">
            <ActivitiesGroup title="4 Simple Student Activities" activities={StudentActivities} />
          </div>
          <Paragraph className="mx-auto max-w-3xl">
            Each activity takes about 15 minutes and helps Mentors offer encouragement, support, and
            prayer throughout the year.
          </Paragraph>
        </div>
      ),
      nextButtonText: "See More",
    },
    {
      id: "mentor_activities",
      renderCustomContent: () => (
        <div className="py-8 text-center">
          <Title>Meaningful Mentor Activities</Title>
          <Paragraph className="mx-auto max-w-3xl">
            Mentors are personally chosen by the student and provide encouragement and support,
            either in-person or from afar.
          </Paragraph>
          <div className="mt-8">
            <ActivitiesGroup title="3 Powerful Mentor Activities" activities={MentorActivities} />
          </div>
          <Paragraph className="mx-auto max-w-3xl">
            Mentors complete three simple 10-minute activities online and share encouragements,
            commitments and a blessing for the year ahead.
          </Paragraph>
        </div>
      ),
      nextButtonText: "Complete Set Up",
    },
    {
      id: "all_set",
      renderCustomContent: () => (
        <div className="py-8 text-center">
          <Title>You&apos;re All Set!</Title>
          <Paragraph>You&apos;re all set to get started with a Mentor Circle Plan today!</Paragraph>
        </div>
      ),
    },
  ]

  const handleComplete = () => {
    navigate("/plan/no-plans")
  }

  return (
    <MultiStepFlowContainer
      steps={steps}
      onComplete={handleComplete}
      initialValues={{}}
      showProgress={true}
      totalStepsOverride={8}
      stepOffset={4}
      stepProgressModifier={1}
      completeButtonText="Begin the Journey!"
      containerClassName="max-w-3xl"
    />
  )
}

export default OnboardingTourFlow
